module.exports = __webpack_public_path__ + "static/media/ic_epg_left.e32236e4.svg";